import apis from '@/utils/apis';

export default {
  data() {
    return {
      bodyNumChangeHandler: null
    };
  },
  mounted() {
    this.bodyNumChangeHandler = this.$debounce(this.onBodyNumChange, 500);
  },
  methods: {
    async onBodyNumChange(row) {
      row.productCode = '';
      const bodyNumPattern = /^[a-zA-Z0-9]{11,}$/;
      const { bodyNum } = row;
      if (bodyNumPattern.test(bodyNum)) {
        // 根据输入的机身号，查询出对应的产品型号
        const res = await this.$getJSON(`${apis.DeviceInfo}?bodyNum=${bodyNum}`);
        if (res && res.data) {
          row.productCode = res.data.productCode;
        }
      }
    }
  }
};
